import React, { useEffect, useRef, useState } from "react";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import Urls from "@egovernments/digit-ui-libraries/src/services/atoms/urls";
import axios from "axios";
import { Loader } from "@egovernments/digit-ui-react-components";
import DialogContentModal from "../../../../../../../templates/ApplicationDetails/components/DialogContent";
import EmployeePendingFiles from "./helper/EmployeePendingFiles";
 
const ProgreesWithOfficer = ({
  tenantId,
  userDetails,
  location,
  department,
  onApplicationSelect,
  dashboardData = [],
  fromDate,
  toDate,
  selectedApplicationType,
}) => {
  const authToken = Digit.UserService.getUser()?.access_token || null;
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [applications, setApplications] = useState([]);
  const requestKeyRef = useRef("");
  const isFetchingRef = useRef(false);
 
  const columns = [
    { id: "srNo", label: "Sr. No." },
    { id: "name", label: "Name" },
    { id: "designation", label: "Designation" },
    { id: "numberOfFiles", label: "Number Of files" },
  ];
 
  const inProgressApps = React.useMemo(() => {
    return (dashboardData || []).filter((item) =>
      item.mainDashBoardStatus?.toLowerCase()?.includes("in progress with officer")
    );
  }, [dashboardData]);
 
  const officerSummary = React.useMemo(() => {
    if (!dashboardData || dashboardData.length === 0) return null;
 
    const map = {};
    inProgressApps.forEach((item) => {
      let assigneeName = item.lastUserName || item.employeName || item.assigneeName || item.currentAssigneeName;
      let roleId = item.lastUserDesignation || item.employeRole || item.roleId;

      if (!assigneeName && item.status && item.status.includes("Pending with")) {
        const match = item.status.match(/Pending with \((.*?)\)(?:\s*\((.*?)\))?/i);
        if (match) {
          assigneeName = match[1];
          if (!roleId && match[2]) roleId = match[2];
        }
      }

      assigneeName = assigneeName || "Unassigned";
      roleId = roleId || "-";

      const key = `${assigneeName}___${roleId}`;
 
      if (!map[key]) {
        map[key] = {
          assigneeName,
          roleId,
          numberOfApplication: 0,
          applicationNumber: [],
        };
      }
      map[key].numberOfApplication += 1;
      if (item.applicationNo) {
        map[key].applicationNumber.push(item.applicationNo);
      }
    });
 
    return Object.values(map).sort((a, b) => b.numberOfApplication - a.numberOfApplication);
  }, [dashboardData, inProgressApps]);
 
  const displayData = officerSummary !== null ? officerSummary : tableData;
 
  useEffect(() => {
    if (!tenantId || !department || !userDetails) return;
 
    const requestKey = `${tenantId}-${location}-${department}-${userDetails?.uuid}-${fromDate}-${toDate}-${selectedApplicationType}`;
 
    if (requestKeyRef.current === requestKey) {
      return;
    }
 
    requestKeyRef.current = requestKey;
 
    getPendingFilesData(tenantId, location, department, userDetails);
  }, [
    tenantId,
    location,
    department,
    userDetails?.uuid,
    fromDate,
    toDate,
    selectedApplicationType,
  ]);
 
  const getPendingFilesData = async (tenantId, location = "All", department, userDetails) => {
    if (isFetchingRef.current) return;
 
    isFetchingRef.current = true;
 
    try {
      setLoading(true);
 
      const postData = {
        RequestInfo: {
          apiId: "Rainmaker",
          authToken,
          msgId: "1781850252247|en_IN",
          userInfo: {
            ...userDetails,
            active: true,
            tenantId,
            permanentCity: null,
          },
        },
      };
 
      const queryParams = new URLSearchParams({
        department,
      });
 
      if (location !== "All") {
        queryParams.append("location", location);
      }
 
      const res = await axios.post(`${Urls.obps.employeeWorkflowCount}?${queryParams.toString()}`, postData);
 
      setTableData(res?.data || []);
    } catch (err) {
      console.error(err);
      setTableData([]);
    } finally {
      isFetchingRef.current = false;
      setLoading(false);
    }
  };
 
  return (
    <React.Fragment>
      {loading && (!dashboardData || dashboardData.length === 0) ? (
        <div
          style={{
            margin: "20px",
          }}
        >
          <Loader />
        </div>
      ) : (
        <TableContainer>
          <caption className="emp-table-caption" style={{ display: "block", textAlign: "left" }}>
            In Progress With Officer
          </caption>
          <Table class="application-table" style={{ width: "100%" }}>
            {/* Header */}
            <thead>
              <tr>
                {columns.map((col, index) => (
                  <th
                    key={col.id}
                    style={{
                      padding: "8px",
                      textAlign: index === 0 ? "center" : "left",
                    }}
                  >
                    {col.label}
                  </th>
                ))}
              </tr>
            </thead>
 
            <tbody>
              {displayData && displayData.length > 0 ? (
                displayData.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.assigneeName}</td>
                    <td>{item?.roleId}</td>
                    <td
                      style={{
                        color: "#0066cc",
                        fontWeight: "bold",
                        cursor: "pointer",
                        textDecoration: "none",
                      }}
                      onClick={() => {
                        setApplications(item?.applicationNumber);
                        setShowModal(true);
                      }}
                    >
                      {item?.numberOfApplication}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4} style={{ textAlign: "center", fontWeight: "bold", padding: "20px" }}>
                    No Records to display
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </TableContainer>
      )}
      {showModal && (
        <DialogContentModal title={"Application Details"} dataOpen={showModal} onClose={() => setShowModal(false)}>
          <EmployeePendingFiles applications={applications} tenantId={tenantId} onApplicationSelect={onApplicationSelect} />
        </DialogContentModal>
      )}
    </React.Fragment>
  );
};
 
export default React.memo(ProgreesWithOfficer);
 
 